<template>
  <div class="prog-stats rating-info col-12 ">
    <div v-if="item.isVod">
      <span>{{item.releaseYear}}</span>
      <span>{{item.durationFormatted}}</span>
      <span v-if="item.rating">{{item.rating}}</span>
    </div>
    <div v-if="item.isBrand">
      <span>{{seasons}}</span>
    </div>
  </div>
</template>
<script>
export default {
  page: 'ratingInfo',
  props: ['item'],
  computed: {
    seasons: function () {
      return `${this.item.seasons.length} Season${this.item.seasons.length > 1 ? 's' : ''}`
    }
  }
}
</script>
